module.exports = __webpack_public_path__ + "static/puzzle.2a31f7b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/img/puzzle.jpg
// module id = 836
// module chunks = 28686525722576